export default __webpack_public_path__ + "static/splashBottom-47ad6cc385e750595bf6fce03a9c8fa1.svg";